import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_Get_Group_Negotiations = {
  communityId: number;
};

export type ApiResponse_Get_Group_Negotiations = Array<{
  id: number;
  title: string;
  description?: string;
  status: string;
  created_at: string;
  updated_at: string;
  closed_at?: string;
  end_date?: string;
  max_member_count?: number;
  metadata?: Record<string, unknown>;
  initiator: {
    id: number;
    user_id: string;
    full_name: string;
    email: string;
    is_verified: boolean;
  };
  member_count: number;
  is_user_member: boolean;
  is_user_initiator: boolean;
}>;

const METHOD = 'GET';
const ENDPOINT = 'communities/{communityId}/group-negotiations';

export const QUERY_KEY = (params: ApiRequest_Get_Group_Negotiations) =>
  getQueryKey(
    METHOD,
    getResolvedEndpoint(ENDPOINT, { communityId: params.communityId.toString() }),
    {}
  );

export const useGetGroupNegotiations = (
  params: ApiRequest_Get_Group_Negotiations,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token && !!params.communityId,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      const data = await handleApiCall<ApiResponse_Get_Group_Negotiations, Record<string, never>>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, { communityId: params.communityId.toString() }),
        {}
      );

      return data;
    },
  });
};
